import { useState } from "react";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Department } from "../../services/coworkerApiCalls/Department/DepartmentsTypes";
import { DepartmentEdit } from "../../components/departments/department";

const AddDepartment: React.FC = () => {
    const [department] = useState<Department>({
        id: 0,
        name: ''
    });

    return (
        <div>
            <DepartmentEdit {...department}></DepartmentEdit>
        </div>
    );
};

export { AddDepartment };